import _ from "lodash";
import {
  accumulateValuesFn,
  dataKeyForPayerType,
  payersNoun,
} from "../../utilities/charts/chart_utils";
import showPayersModal from "../../utilities/charts/payers_modal";
import PayersLivesDonutChartBase from "./payers_lives_donut_chart_base";

export default class extends PayersLivesDonutChartBase {
  calculateFractions(coverageMetric) {
    let hasAuthLength = 0;

    let total = 0;

    _.forIn(_.pick(this.params[this.drug], this.payerTypesShown), (values, payerType) => {
      const yesValues = this.yesValues(values);
      const allValues = _.flatten(_.values(values));

      const accumulate = accumulateValuesFn(payerType, coverageMetric);

      total += accumulate(allValues);
      hasAuthLength += accumulate(yesValues);
    });

    const mainFraction = total === 0 ? 0 : hasAuthLength / total;

    return {
      mainFraction,
      increaseFraction: 0,
      decreaseFraction: 0,
    };
  }

  triggerModalInternal(collection) {
    const isYes = collection !== "remainder";

    const payerTypes = this.payerTypesShown.map(dataKeyForPayerType);

    const payers = _.mapValues(_.pick(this.params[this.drug], payerTypes), valuesByType =>
      isYes ? this.yesValues(valuesByType) : _.flatten(_.values(_.omit(valuesByType, "Yes"))),
    );

    const verb = isYes ? "with" : "without";
    const title = `${payersNoun(payerTypes)} ${verb} PA Auth/Reauth Length for ${this.drug}`;

    showPayersModal(this.drug, title, payers);
  }

  get titleText() {
    const nouns = payersNoun(this.payerTypesShown);

    return `${nouns} & Lives with PA Auth/Reauth Length for ${this.drug}`;
  }

  get tooltipTitleText() {
    return "Has PA Auth/Reauth Length?";
  }
}
